import Vue from 'vue';
import moment from 'moment';
import i18n from '@/i18n';
import BasicHelper from '@/helpers/BasicHelper.js'

Vue.filter('formatDate', function (value, format, useDate = false) {
  if (value) {
    if (useDate) {
      value = new Date(value).toISOString();
    }
    return moment(String(value)).format(format);
  }
});

Vue.filter('formatPhone', function (value) {
  let returnVal = '';
  if (value) {
    value = value + '';
    let offset = value.length - 3;
    while (offset >= 0) {
      returnVal = value.substr(offset, 3) + ' ' + returnVal;
      offset = offset - 3;
    }
    if (offset > -3) {
      returnVal = value.substr(0, 3 + offset) + ' ' + returnVal;
    }
  }
  return returnVal.trim();
});

Vue.filter('formatPhones', function (values, join = '\n') {
  const returnVals = [];
  values.forEach(function (item) {
    if (typeof item === typeof {}) {
      returnVals.push(Vue.filter('formatPhone')(item.number));
    } else {
      returnVals.push(Vue.filter('formatPhone')(item));
    }
  })
  return returnVals.join(join);
});

Vue.filter('formatFromConfig', function (value, config, configParam = null, lang = null) {
  if (value && config && config[value]) {
    return BasicHelper.getConfigValueText(config[value], configParam, (lang !== null), lang, i18n.fallbackLocale);
  }
});

Vue.filter('formatDateRange', function (data, dateFormat = 'DD.MM.YYYY', timeFormat = 'HH:mm', emptyValue = '-') {
  const momentFrom = (data.fromDate ? moment(data.fromDate) : null);
  const momentTo = (data.toDate ? moment(data.toDate) : null);
  let fullFormat = dateFormat;
  if (timeFormat) {
    fullFormat += timeFormat;
  }
  if (momentFrom) {
    let resStr = '';
    if (momentTo == null || momentFrom.format(dateFormat) === momentTo.format(dateFormat)) {
      resStr = momentFrom.format(fullFormat);
      if (timeFormat && momentTo) {
        resStr += ' - ' + momentTo.format(timeFormat);
      }
    } else {
      resStr = momentFrom.format(fullFormat);
      if (momentTo) {
        resStr += ' - ' + momentTo.format(fullFormat);
      }
    }
    return resStr;
  }
  return emptyValue;
});

Vue.filter('formatLineOnEmpty', function (value) {
  if (value === undefined || value === null || value === '') {
    return '-';
  }
  return value;
});

Vue.filter('formatDecimal', function (data, precision, locale, floor = false, lineOnZero = false) {
  if (data === '' || data === null || data === undefined || (lineOnZero && parseFloat(data) === 0)) {
    return '-';
  }
  if (precision === undefined) {
    return data.toLocaleString(locale, { maximumFractionDigits: 20 });
  } else {
    const multi = Math.pow(10, precision);
    if (floor) {
      data = Math.floor(parseFloat(data) * multi) / multi;
    } else {
      data = Math.round(parseFloat(data) * multi) / multi;
    }
    return data.toLocaleString(locale, { minimumFractionDigits: precision });
  }
});

Vue.filter('formatPercent', function (data) {
  if (data === '' || data === null) {
    return '-';
  }
  return Math.round(parseFloat(data) * 10000) / 100 + '%';
});

Vue.filter('formatArraySingleParam', function (array, param) {
  return array.map(val => val[param]).join(', ');
});

Vue.filter('modelClassname', (id, config) => {
  if (config[id]) {
    return config[id].classname.split('\\').pop();
  }
  return '';
});
